import { render, staticRenderFns } from "./VulnDetail.vue?vue&type=template&id=78146e5d&scoped=true&"
import script from "./VulnDetail.vue?vue&type=script&lang=ts&"
export * from "./VulnDetail.vue?vue&type=script&lang=ts&"
import style0 from "./VulnDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VulnDetail.vue?vue&type=style&index=1&id=78146e5d&scoped=true&lang=scss&"
import style2 from "./VulnDetail.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78146e5d",
  null
  
)

export default component.exports